import { useCallback } from 'react';

import { Button } from '@/lib/base/buttons/button';
import type { CardinalityConflict } from '@/lib/crm/core/types';

/**
 * A conflicting record's name, rendered as a link that opens its slideout so
 * the user can fix the association without leaving the create form.
 */
export function ConflictName({
  conflict,
  onOpenSlideout,
}: {
  conflict: CardinalityConflict;
  onOpenSlideout: (entityId: string) => void;
}) {
  const label = conflict.display_name || 'another record';
  const handleClick = useCallback(
    () => onOpenSlideout(conflict.entity_id),
    [onOpenSlideout, conflict.entity_id]
  );
  return (
    <Button color='link-color' size='sm' onClick={handleClick}>
      {label}
    </Button>
  );
}
